import { Figure } from '../../atoms/figure/Figure';
import { Link } from '../../atoms/link/Link';

export function Logo(props: { disableLink?: boolean }) {
    return (
        <Link
            className="logo"
            isDisabled={props.disableLink}
            to={'/'}
        >
            <Figure
                alt="Ksyos Logo"
                className="logo--img"
                imageUrl="/assets/images/ksyos-logo.png"
            />
            <Figure
                alt="Ksyos"
                className="logo--text"
                imageUrl="/assets/images/ksyos-logo-text.svg"
            />
        </Link>
    );
}
